import { OPEN_WORD_VIEWER, CLOSE_WORD_VIEWER } from "./actionTypes";
const initialState = {
  isOpen: false,
  wordFile: null,
};
const WordViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_WORD_VIEWER:
      return {
        ...state,
        isOpen: true,
        wordFile: action.payload,
      };

    case CLOSE_WORD_VIEWER:
      return {
        ...state,
        isOpen: false,
        wordFile: null,
      };
    default:
      return state;
  }
};
export default WordViewerReducer;
